/**
 * Regras de título e descrição de toda página pública. Puro (sem React):
 * as telas, o gerador de `llms.txt`/markdown e o teste de SEO importam daqui,
 * então a regra medida é a mesma que renderiza.
 */

export const SITE_NAME = 'Controlapag';
export const TITLE_SUFFIX = ' · Controlapag';
/** Acima disso o Google corta o título no resultado. */
export const TITLE_MAX = 60;
export const DESCRIPTION_MIN = 120;
export const DESCRIPTION_MAX = 160;

/**
 * Título renderizado: acrescenta " · Controlapag" só quando cabe em
 * `TITLE_MAX` e o nome ainda não está no texto. Sem sufixo, a marca continua
 * no `og:site_name` e no JSON-LD.
 */
export function pageTitle(title: string): string {
  if (title.includes(SITE_NAME)) return title;
  const withSuffix = `${title}${TITLE_SUFFIX}`;
  return withSuffix.length <= TITLE_MAX ? withSuffix : title;
}
